import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { DepositRepayment } from '~/shared/api/depositRepayment'
import { AsyncGrid, FetchRowsFn } from '~/shared/ui/AsyncGrid'
import { columns } from './columns'
import { GridRow } from './types'

type DepositRepaymentListProps = {
  debtId: UniqueId
  gridKey: string
}

export const DepositRepaymentList = (props: DepositRepaymentListProps) => {
  const { t } = useTranslation()
  const { debtId, gridKey } = props
  const fetchRows = useCallback<FetchRowsFn<GridRow>>(
    async (page, pageSize, _, sort) => {
      let builder = DepositRepayment.limit(pageSize)
        .where('debtId', debtId)
        .with('user')

      sort
        ? (builder = builder.orderBy(sort))
        : (builder = builder.orderBy('-createdAt'))

      const response = await builder.get(page)
      const data = response.getData()
      const rows = data.map((depositRepayment: DepositRepayment) => ({
        ...depositRepayment?.getAttributes(),
        user: depositRepayment?.getUser()?.getTitle(),
        id: depositRepayment?.getApiId() as UniqueId,
      }))

      const httpClientResponse = response.getHttpClientResponse()
      const axiosResponse = httpClientResponse?.getUnderlying()
      const total = axiosResponse?.data?.meta?.page?.total || 0

      return {
        rows,
        total,
      }
    },
    [debtId],
  )

  return (
    <AsyncGrid<GridRow>
      smallTitle={t('deposit repayments list')}
      gridKey={gridKey}
      fetchRows={fetchRows}
      columns={columns}
      memoryLocal
    />
  )
}
